import {Partner} from '@soluto-private/mx-context-types';

/**
 * DEPRECATED: This has never worked! Do not use!
 * Returns a list of active partners of the authenticated user.
 * @returns Partner[]
 * @deprecated
 */
export const getUserPartners = (): Promise<Partner[]> => Promise.resolve([]);
